module.exports = __webpack_public_path__ + "static/media/play.31e2f0fb.svg";